import React, { useEffect, useMemo, useRef } from 'react';
import { useFormikContext, Field, FieldArray } from 'formik';
import { Box, Grid, Paper, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { CheckboxUI, DatagridPremiumUi, FormErrorUI, InputUI, SelectUI, TimePickerUi } from '../../Interface';
import { AlertUnitEnum, AlertUnitList, MonthDaysList, WeekDaysList } from '../../../config/alert';

const AlertFormSchedule = () => {
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  useEffect(() => {
    const unit = values.alertSchedule?.unit;

    if (unit === AlertUnitEnum.DAY || unit === AlertUnitEnum.WEEK || unit === AlertUnitEnum.MONTH) {
      if (!values.alertSchedule?.time) {
        setFieldValue(
          'alertSchedule.time',
          dayjs().set('hour', 8).set('minute', 0).set('second', 0).set('millisecond', 0)
        );
      }
    } else {
      setFieldValue('alertSchedule.time', null);
    }

    if (unit !== AlertUnitEnum.WEEK && values.alertSchedule?.weekday != null) {
      setFieldValue('alertSchedule.weekday', null);
    }

    if (unit !== AlertUnitEnum.MONTH && values.alertSchedule?.monthDay != null) {
      setFieldValue('alertSchedule.monthDay', null);
    }

    if (
      unit === AlertUnitEnum.WEEK &&
      (values.alertSchedule?.weekday === null ||
        values.alertSchedule?.weekday === undefined ||
        values.alertSchedule?.weekday === '')
    ) {
      setFieldValue('alertSchedule.weekday', 1);
    }

    if (
      unit === AlertUnitEnum.MONTH &&
      (values.alertSchedule?.monthDay === null ||
        values.alertSchedule?.monthDay === undefined ||
        values.alertSchedule?.monthDay === '')
    ) {
      setFieldValue('alertSchedule.monthDay', 1);
    }
  }, [values.alertSchedule.unit]);

  return (
    <Box sx={{ overflowX: 'auto' }} pt={1}>
      <Box
        elevation={1}
        sx={{
          overflow: 'hidden',
        }}
      >
        <Typography variant="body2" color="text.secondary" fontWeight={600} fontSize={'1rem'} my={1}>
          Gyakoriság
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={4} container justifyContent="flex-end" alignItems="center">
            <Typography variant="body2" color="text.secondary">
              Minden
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Field
              type="number"
              name="alertSchedule.every"
              as={InputUI}
              fullWidth
              variant="standard"
              inputProps={{ min: 1 }}
              helperText={<FormErrorUI message={errors.alertSchedule?.every} />}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <Field
              name="alertSchedule.unit"
              component={SelectUI}
              fullWidth
              option={AlertUnitList}
              value={values.alertSchedule.unit ?? ''}
              variant="standard"
              onChange={(e) => {
                const value = e.target.value;
                setFieldValue('alertSchedule.unit', value ?? null).then(() => {
                  validateField('alertSchedule.unit');
                });
              }}
              helperText={<FormErrorUI message={errors.alertSchedule?.unit} />}
            />
          </Grid>
        </Grid>
        {values.alertSchedule?.unit === AlertUnitEnum.WEEK && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} container justifyContent="flex-end" alignItems="center">
              <Typography variant="body2" color="text.secondary">
                Hét napja
              </Typography>
            </Grid>
            <Grid item xs={12} md={8}>
              <Field
                name="alertSchedule.weekday"
                component={SelectUI}
                fullWidth
                option={WeekDaysList}
                value={values.alertSchedule.weekday ?? ''}
                variant="standard"
                onChange={(e) => {
                  const value = e.target.value;
                  setFieldValue('alertSchedule.weekday', value ?? null).then(() => {
                    validateField('alertSchedule.weekday');
                  });
                }}
                helperText={<FormErrorUI message={errors.alertSchedule?.weekday} />}
              />
            </Grid>
          </Grid>
        )}

        {values.alertSchedule?.unit === AlertUnitEnum.MONTH && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} container justifyContent="flex-end" alignItems="center">
              <Typography variant="body2" color="text.secondary">
                Hónap napja
              </Typography>
            </Grid>
            <Grid item xs={12} md={8}>
              <Field
                type="number"
                name="alertSchedule.monthDay"
                as={SelectUI}
                fullWidth
                option={MonthDaysList}
                variant="standard"
                value={values.alertSchedule.monthDay ?? ''}
                onChange={(e) => {
                  const value = e.target.value;
                  setFieldValue('alertSchedule.monthDay', value ?? null).then(() => {
                    validateField('alertSchedule.monthDay');
                  });
                }}
                helperText={<FormErrorUI message={errors.alertSchedule?.monthDay} />}
              />
            </Grid>
          </Grid>
        )}

        {values.alertSchedule?.unit === AlertUnitEnum.DAY ||
        values.alertSchedule?.unit === AlertUnitEnum.WEEK ||
        values.alertSchedule?.unit === AlertUnitEnum.MONTH ? (
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} container justifyContent="flex-end" alignItems="center">
              <Typography variant="body2" color="text.secondary">
                Időpont
              </Typography>
            </Grid>
            <Grid item xs={12} md={8}>
              <Field
                name="alertSchedule.time"
                component={TimePickerUi}
                fullWidth
                value={values.alertSchedule.time ? dayjs(values.alertSchedule.time) : null}
                variant="standard"
                onChange={(newValue) => {
                  setFieldValue('alertSchedule.time', newValue ?? null).then(() => {
                    validateField('alertSchedule.time');
                  });
                }}
                helperText={<FormErrorUI message={errors.alertSchedule?.time} />}
              />
            </Grid>
          </Grid>
        ) : null}
      </Box>
    </Box>
  );
};

export default AlertFormSchedule;
